import { render, staticRenderFns } from "./ProducerForm.vue?vue&type=template&id=3b29801c&scoped=true&"
import script from "./ProducerForm.vue?vue&type=script&lang=js&"
export * from "./ProducerForm.vue?vue&type=script&lang=js&"
import style0 from "./ProducerForm.vue?vue&type=style&index=0&id=3b29801c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b29801c",
  null
  
)

export default component.exports